Ext.ns('mx.tpl.lang');

mx.tpl.lang.Formatter = function() {};

mx.tpl.lang.Formatter.F = {
    TIME: function() {
        return this.isTwelveHourSystem ? 'h:i A' : 'H:i';
    },
    TIME_WITHOUT_COLON: function() {
        return this.isTwelveHourSystem ? 'hiA' : 'Hi';
    },
    DATE_WITHOUT_YEAR: function() {
        return mx.tpl.lang.Formatter.F.dateFormat.call(this);
    },
    DATE_WITH_SHORT_YEAR: function() {
        return mx.tpl.lang.Formatter.F.dateFormat.call(this, 'short');
    },
    DATE_WITH_FULL_YEAR: function() {
        return mx.tpl.lang.Formatter.F.dateFormat.call(this, 'full');
    },
    //private
    dateFormat: function(yearFormat) {
        return this.dateSequence
            .map(function(segment) {
                switch (segment) {
                    case 'DAY':
                        return 'd';
                    case 'MONTH':
                        return 'm';
                    case 'YEAR':
                        return yearFormat && (yearFormat == 'short' ? 'y' : 'Y');
                }
            }, this)
            .filter(function(s) {
                return s;
            })
            .join(this.dateDivider);
    },
};

mx.tpl.lang.Formatter.prototype.formatDateTime = function(
    /*Date*/ dateTime /*mx.tpl.lang.Formatter.F... formatSegments*/
) {
    if (arguments.length < 2) throw 'Invalid arguments';

    var pattern = this.dateTimePattern.apply(this, Array.prototype.slice.call(arguments, 1));

    return dateTime.format(pattern);
};

mx.tpl.lang.Formatter.prototype.dateTimePattern = function(/*mx.tpl.lang.Formatter.F... formatSegments*/) {
    if (arguments.length < 1) throw 'Invalid arguments';

    return Array.prototype.map
        .call(
            arguments,
            function(segment) {
                if (typeof segment == 'string') {
                    segment = mx.tpl.lang.Formatter.F[segment];
                }
                return segment.call(this);
            },
            this
        )
        .join(' ');
};

mx.tpl.lang.Formatter.prototype.formatGeoAddress = function(/*GeoAddress*/ address) {
    if (arguments.length < 1) throw 'Invalid arguments';

    return this.addressSequence
        .map(function(segment) {
            switch (segment) {
                case 'INFO':
                    return address.getDescription();
                case 'STREET':
                    return address.getStreet();
                case 'CITY':
                    return address.getCity();
                case 'COUNTRY':
                    return address.getCountry();
                case 'DISTRICT':
                    return address.getDistrict();
                case 'STATE':
                    return address.getState();
                case 'COUNTY':
                    return address.getCounty();
                case 'ZIP':
                    return address.getZip();
            }
        })
        .filter(function(s) {
            return s;
        })
        .join(', ');
};
